export default __webpack_public_path__ + "static/media/news2.a96550a6.png";